import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { apiAssessors, apiCodeLists } from 'helpers/decorators/api'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import styles from './assessor-affiliations.styl'
import { Button, Module } from '../../../misc'
import { InviteAssessorActivityCategoryModal, RemoveAssessorActivityApprovalModal } from 'components/modals'
import MODALS from '../../../../constants/modals'
import { getActivityName, getCategoryName, getSection } from '../../../../helpers/assessorHelper'

const enhance = compose(
  connect(({ auth, api }) => ({
    activeOrganization: auth.organization,
    affiliations: get(api, 'assessors.affiliationsOverview.data') || [],
    registrations: get(api, 'assessors.registrations.list') || [],
    isLoading: get(api, 'assessors.affiliationsOverview.loading')

  })),
  apiCodeLists(['personStates']),
  apiAssessors()
)

class AssessorsAffiliations extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    personId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    getAssessorOverview: PropTypes.func.isRequired,
    deleteAssessorActivity: PropTypes.func.isRequired,
    inviteAssessorToActivityCategory: PropTypes.func.isRequired,
    onGetAssessorsActivityCategoryRegistrations: PropTypes.func.isRequired,
    affiliations: PropTypes.array.isRequired,
    registrations: PropTypes.array.isRequired,
    modal: PropTypes.func.isRequired,
    assessors: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired
  }

  static defaultProps = {
    data: {}
  }

  state = {
    activity: null
  }

  componentDidMount = () => {
    this.props.getAssessorOverview(this.props.personId)
    this.props.onGetAssessorsActivityCategoryRegistrations(get(this.props, 'assessors.registrations'), this.props.personId)
  }

  handleOpenModal = () => {
    this.props.modal(MODALS.ASSESSOR_ACTIVITY_CATEGORY_INVITATION_MODAL)
  }

  handleOpenDeleteActivityModal = activity => {
    this.setState(
      {
        activity
      },
      () => this.props.modal(MODALS.ASSESSOR_REMOVE_ACTIVITY_MODAL)
    )
  }

  render () {
    const {
      affiliations,
      registrations,
      deleteAssessorActivity,
      inviteAssessorToActivityCategory,
      organizationId,
      personId,
      isLoading
    } = this.props

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': () => this.handleOpenModal(),
        'iconAction': 'settings',
        'isActionLoading': isLoading,
        'intlKeyAction': 'button.add_more',
        'action': 'Add more'
      }
    ]

    return (
      <div>
        <Module
          primary
          grid
          title="Award Centres and Activities"
          intlKey="moduleTitle.award_centres_and_activities"
          buttonDefinition={buttonDefinition}
        >
          <div className="row">
            <div className="col-xs-12">
              <div className={styles.affiliations}>
                {affiliations.map(item => (
                  <div>
                    <FormattedMessage
                      id="label.name"
                      defaultMessage="Name"
                    />
                    <p>{get(item, 'organization.name')}</p>
                    <div>
                      <FormattedMessage
                        id="label.activities"
                        defaultMessage="Activities"
                      />
                      {get(item, 'activityList').map(act => (
                        <div className={styles.activity}>
                          <div className="row">
                            <div className="col-xs-8">
                              <p>{get(act, 'section')} - {get(act, 'activityName')} - {get(act, 'activityCategoryName')} {!get(act, 'publicAvailable') &&
                                <FormattedMessage
                                  id="label.did_not_consent_to_assess_others_without_name"
                                  defaultMessage="(did not consent to assess other participants)"
                                />}</p>
                            </div>
                            <div className="col-xs-4">
                              <Button
                                className={styles.activityButton}
                                type="button"
                                intlKey="button.remove"
                                secondary
                                onClick={() => this.handleOpenDeleteActivityModal(act)}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div className={styles.affiliations}>
                <FormattedMessage
                  id="label.registrations"
                  defaultMessage="Registrations"
                />
                {registrations.length === 0 && <div className="row">
                  <div className="col-xs-8">
                    <FormattedMessage
                      id="label.no_registrations"
                      defaultMessage="No pending registrations."
                      tagName="p"
                    />
                  </div>
                </div>}
                {registrations.length > 0 && registrations.map((item) => (
                  <div>
                    <div className={styles.activity}>
                      <div className="row">
                        <div className="col-xs-8">
                          <p>{getSection(item)} - {getActivityName(item)} - {getCategoryName(item)}</p>
                        </div>
                        <div className="col-xs-4">
                          <p>{get(item, 'state.translationText')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Module>
        <RemoveAssessorActivityApprovalModal
          modalId={MODALS.ASSESSOR_REMOVE_ACTIVITY_MODAL}
          data={this.state.activity}
          personId={personId}
          modal={this.props.modal}
          onApprove={deleteAssessorActivity}
        />
        <InviteAssessorActivityCategoryModal
          modalId={MODALS.ASSESSOR_ACTIVITY_CATEGORY_INVITATION_MODAL}
          modal={this.props.modal}
          personId={personId}
          orgId={organizationId}
          isLoading={isLoading}
          onApprove={inviteAssessorToActivityCategory}
        />
      </div>
    )
  }
}

export default enhance(AssessorsAffiliations)
